import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { RelatorioDemonstrativoReceitaDespesaAnualResponse, FiltroRelatorioReceitaDespesaAnual } from "../typings";
import http  from 'infra/http';

export function useRelatorioDemonstrativoReceitaDespesaAnual(query: FiltroRelatorioReceitaDespesaAnual) {
  return useQuery<RelatorioDemonstrativoReceitaDespesaAnualResponse, AxiosError>(
    ['/v1/relatorios/financeiro/demonstrativo-receita-despesa/anual', query],
    async () => {
      const {data} = await http.get('/v1/relatorios/financeiro/demonstrativo-receita-despesa/anual', {
        params: query
      })

      return data;
    }
  );
}
